import React from 'react';
import { useTranslation } from '@shared/core';
import { Box, Flex, SpacingStack, TextV2 } from '@withjoy/joykit';
import { Page } from '../../components/LayoutStructure';
import { CustomLi, CustomUl, styles } from './ReturnPolicy.styles';
import { wrapWithReturnPolicyHealthProvider } from '@apps/registry/common/components/Catalog/routes/ReturnPolicy/ReturnPolicy.health';
import { Seo } from '@shared/components/Seo';

export const ReturnPolicy = wrapWithReturnPolicyHealthProvider(() => {
  const { t } = useTranslation('companyPolicies');
  const { seo, hero, topSection, sections } = t('returnPolicy');

  return (
    <Page>
      <Seo
        title={seo.title()}
        description={seo.description()}
      />
      <Flex __css={styles.policyContainer}>
        <TextV2
          __css={styles.title}
          typographyVariant="HedHero72"
        >
          {hero.title()}
        </TextV2>
        <Box
          __css={styles.date}
          typographyVariant="hed4"
          fontWeight="regular"
        >
          {hero.date()}
        </Box>
        <Box __css={styles.blockContainer}>
          <TextV2
            __css={styles.paragraph}
            typographyVariant="body3"
          >
            {hero.subtitle()}
          </TextV2>
        </Box>
        <Box __css={styles.blockContainer}>
          <TextV2
            __css={styles.sectionTitle}
            typographyVariant="body3"
            fontWeight="semibold"
            marginTop={7}
          >
            {topSection.title()}
          </TextV2>
          <TextV2
            __css={styles.sectionTitle}
            typographyVariant="body3"
            marginBottom={6}
          >
            {topSection.description()}
          </TextV2>
          <CustomUl>
            {topSection.listItems.map((item, itemIndex) => (
              <CustomLi
                marginBottom={6}
                key={itemIndex}
                typographyVariant="body3"
                dangerouslySetInnerHTML={{ __html: item.text() }}
              />
            ))}
          </CustomUl>
        </Box>
        <Box __css={styles.blockContainer}>
          {sections.map((section, sectionIndex) => (
            <SpacingStack
              key={sectionIndex}
              __css={styles.sectionsContainer}
              spacing={3}
            >
              <TextV2
                __css={styles.sectionTitle}
                typographyVariant="body3"
                fontWeight="semibold"
              >
                {section.title()}
              </TextV2>
              <SpacingStack spacing={7}>
                {section.subsections.map((subsection, subsectionIndex) => (
                  <SpacingStack
                    key={subsectionIndex}
                    spacing={3}
                  >
                    <TextV2
                      __css={styles.sectionTitle}
                      typographyVariant="body3"
                    >
                      {subsection.title()}
                    </TextV2>
                    {!!subsection.listItems.length && (
                      <CustomUl __css={styles.list}>
                        {subsection.listItems.map((item, itemIndex) => (
                          <CustomLi
                            key={itemIndex}
                            as="li"
                            typographyVariant="body3"
                            __css={styles.listItem}
                            dangerouslySetInnerHTML={{ __html: item.text() }}
                          />
                        ))}
                      </CustomUl>
                    )}
                    {!!subsection.listIndentedItems.length && (
                      <CustomUl __css={styles.listIndented}>
                        {subsection.listIndentedItems.map((item, itemIndex) => (
                          <CustomLi
                            key={itemIndex}
                            as="li"
                            __css={styles.listItem}
                            dangerouslySetInnerHTML={{ __html: item.text() }}
                          />
                        ))}
                      </CustomUl>
                    )}
                    {/* {!!subsection.listNoBulletItems.length && ( Might be used later
                      <CustomUl __css={styles.listNoBullet}>
                        {subsection.listNoBulletItems.map((item, itemIndex) => (
                          <Box key={itemIndex} as="li" __css={styles.listItem} dangerouslySetInnerHTML={{ __html: item.text() }} />
                        ))}
                      </CustomUl>
                    )} */}
                  </SpacingStack>
                ))}
              </SpacingStack>
            </SpacingStack>
          ))}
        </Box>
      </Flex>
    </Page>
  );
});
